import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  ledgerProductCodeCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";

/**
 * Désactive un code produit (`DELETE /ProductCodes/{id}`) — réservé à
 * flashpay-superadmin. Seul le code HTTP fait foi (pas de corps typé).
 */
export const useDeleteProductCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "product-codes", "delete"],
    mutationFn: (productCodeId: string) =>
      mutateData({
        url: ledgerEndpoints.productCodes.delete(productCodeId),
        method: "DELETE",
      }),
    onSuccess: (_data, productCodeId) => {
      return invalidateAfterMutation(
        queryClient,
        ledgerProductCodeCacheKeys(productCodeId)
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteProductCode failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
